import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const CardPriceWrapper = styled.div`
  &.has-euro-price {
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    align-items: center;
  }

  @media print {
    width: 30%;
  }

  .price-label > *:is(p, span) {
    color: var(--dui-color-black-500);
    margin: var(--dui-size-space-5x) 0;

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-bottom: var(--gaq-size-space-3px);
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      margin-bottom: 0;
    }
  }
`;
